import ActionTypes from "../constants/action_types";

export default function clearTopics(organisationId) {
  return {
    type: ActionTypes.TOPICS_CLEAR.SUCCESS,
    organisation_id: organisationId,
  };
}
